define("@latermedia/ember-later-analytics/utils/state-types/backfilling-data", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  /**
   * @module Utils
   */

  /**
   * @class BackfillingDataUtil
   * @extends Utils
   */

  /**
   * Backfilling Data State
   *
   * @property BACKFILLING_DATA
   * @returns {string}
   */
  const BACKFILLING_DATA = 'backfillingData';
  var _default = _exports.default = BACKFILLING_DATA;
});